var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatherMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.864,
    height: 44.234,
    viewBox: "0 0 55.864 44.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-mail",
    "data-name": "Icon feather-mail",
    transform: "translate(2.785 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_311",
    "data-name": "Trazado 311",
    d: "M8.029,6H48.264a5.044,5.044,0,0,1,5.029,5.029V41.205a5.044,5.044,0,0,1-5.029,5.029H8.029A5.044,5.044,0,0,1,3,41.205V11.029A5.044,5.044,0,0,1,8.029,6Z",
    transform: "translate(-3 -6)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_312",
    "data-name": "Trazado 312",
    d: "M53.294,9,28.147,26.6,3,9",
    transform: "translate(-3 -3.971)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherMail);
export default __webpack_public_path__ + "static/media/feather-mail.bda026206d44760cc8e7cf75206d7e1c.svg";
export { ForwardRef as ReactComponent };